import { LogoImgDefault } from './LogoImgDefault.js';

export const LogoImgAttraction = (label, type, slug) => {
    if (label === 'icon') {
        try {
            const datas = require(`../assets/images/attractions/${type}/${slug}/icon/${slug}.webp`);
            return datas.length > 0 ? datas : LogoImgDefault('icon');
        } catch(e) {
            console.log(e);
            return LogoImgDefault('icon');
        }
    }
    if (label === 'img') {
        try {
            const images = require.context(`../assets/images/attractions`, true, /\.(webp)$/i);
            const gallery = (type, slug) => {
                return images.keys()
                    .filter(path => path.startsWith(`./${type}/${slug}/img`))
                    .map(path => (images(path)));
            }
            return gallery(type, slug).length > 0 ? gallery(type, slug) : LogoImgDefault('img');
        } catch(e) {
            console.log(e);
            return LogoImgDefault('img')
        }
    }
}
